module.exports = function() {
  return new Worker(__webpack_public_path__ + "53b305856ee9629ad2cc.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/worker-loader/dist/cjs.js!./node_modules/pdfjs-dist/es5/build/pdf.worker.js
// module id = 303
// module chunks = 0